import { Filter } from "lucide-react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Dispatch, FC, SetStateAction, useState } from "react";

interface Props {
  setDifficulty: Dispatch<SetStateAction<string | null>>;
}

export const options = [
  {
    label: "All",
    value: "all",
    color:"text-gray"
  },
  {
    label: "General",
    value: null,
    color:"text-[#363F72]"
  },
  {
    label: "Easy",
    value: "easy",
    color : "text-green-500"
  },
  {
    label: "Medium",
    value: "medium",
    color: "text-orangeButton"
  },
  {
    label: "Hard",
    value: "hard",
    color : "text-red-500"
  },
];

const TrackDifficultyFilter: FC<Props> = ({ setDifficulty }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (value: string | null) => {
    setOpen(false);
    setDifficulty(value);
  };

  return (
    <Popover open={open}>
      <PopoverTrigger asChild>
        <Button
          variant="outline"
          className="text-black h-[40px] shadow-none"
          onClick={() => setOpen((o) => !o)}
        >
          <Filter />
          Difficulty
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[150px] p-2">
        {options.map((option) => (
          <Button
            key={option.label}
            variant="ghost"
            className="w-full text-black"
            onClick={() => handleClick(option.value)}
          >
            {option.label}
          </Button>
        ))}
      </PopoverContent>
    </Popover>
  );
};

export default TrackDifficultyFilter;
